module.exports = __webpack_public_path__ + "img/kristine.e92028f9.jpg";